package com.example.socialmediaapp.network

import com.example.socialmediaapp.data.models.Story
import com.example.socialmediaapp.data.models.StoryGroup
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ApiStory(
    val id: String,
    @SerialName("user_id") val userId: String,
    val username: String = "",
    @SerialName("media_url") val mediaUrl: String,
    @SerialName("thumbnail_url") val thumbnailUrl: String? = null,
    @SerialName("is_video") val isVideo: Int = 0,
    @SerialName("created_at") val createdAt: Long = 0L,
    @SerialName("expires_at") val expiresAt: Long = 0L
) {
    fun toDomain() = Story(
        id = id,
        userId = userId,
        mediaUrl = mediaUrl,
        thumbnailUrl = thumbnailUrl,
        isVideo = isVideo != 0,
        timestamp = createdAt * 1000L,
        expiresAt = expiresAt * 1000L
    )
}

@Serializable
data class CreateStoryRequest(
    val mediaUrl: String,
    val thumbnailUrl: String? = null,
    val isVideo: Boolean = false
)

@Serializable
data class CreateStoryResponse(val id: String = "")

class StoriesRepository(private val api: ApiClient) {

    suspend fun getStoryGroups(): Result<List<StoryGroup>> = runCatching {
        val stories = api.get<List<ApiStory>>("/api/stories")
        // Group flat list by userId
        stories
            .groupBy { it.userId }
            .map { (_, userStories) ->
                val first = userStories.first()
                StoryGroup(
                    userId = first.userId,
                    username = first.username,
                    stories = userStories.map { it.toDomain() }
                )
            }
    }

    suspend fun createStory(mediaUrl: String, thumbnailUrl: String? = null, isVideo: Boolean = false): Result<String> = runCatching {
        api.post<CreateStoryResponse>("/api/stories", CreateStoryRequest(mediaUrl, thumbnailUrl, isVideo)).id
    }
}
